export default "__VITE_ASSET__D_aMPTEx__"